import { mergePrismicPreviewData } from 'gatsby-source-prismic'

const usePreview = data => {
  const previewData =
    typeof window !== 'undefined' && window.__PRISMIC_PREVIEW_DATA__

  if (!previewData) {
    return data
  }

  const merged = mergePrismicPreviewData({ data, previewData })
  return {
    ...data,
    ...merged
  }
}

export default usePreview
